import style from '../../styles/components/story/story'

const Link = ({ author }) => (
  <>
    <a href={`/authors/${author.slug}`}>{author.byline}</a>
    <style jsx>{style}</style>
  </>
)

const TwoAuthors = ({ authors }) => (
  <>
    <Link author={authors[0]} />
    <span> and </span>
    <Link author={authors[1]} />
    <style jsx>{style}</style>
  </>
)

const ManyAuthors = ({ authors }) => {
  const lastIndex = authors.length - 1
  const exceptLast = authors.slice(0, lastIndex)
  const last = authors[lastIndex]

  return (
    <>
      {exceptLast.map((a) => (
        <span key={a.slug}>
          <Link author={a} />
          <span>, </span>
        </span>
      ))}
      <span>and </span>
      <Link author={last} />
      <style jsx>{style}</style>
    </>
  )
}

const Byline = ({ authors }) => {
  const activeAuthors = authors.filter((author) => author.active)

  if (!activeAuthors?.length) {
    return null
  }

  return (
    <>
      <div className='byline'>
        <span>By </span>
        {activeAuthors.length === 1 ? (
          <Link author={activeAuthors[0]} />
        ) : activeAuthors.length === 2 ? (
          <TwoAuthors authors={activeAuthors} />
        ) : (
          <ManyAuthors authors={activeAuthors} />
        )}
      </div>
      <style jsx>{style}</style>
    </>
  )
}

export default Byline
